import MSINav from "./MSINav";
//import closedTrades from "./data/msi-closed.json";
import closedSeed from "./data/msi-closed.json";
import { useEffect, useState } from "react";

const panel = {
  background: "#171717",
  border: "1px solid #2A2A2A",
  borderRadius: 12,
  padding: 18,
};

function fmt(n, d = 1) {
  if (n === null || n === undefined) return "-";
  return Number(n).toFixed(d);
}

function fmtDate(value) {
  if (!value) return "-";

  return new Date(value).toLocaleString([], {
    year: "2-digit",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

function avg(arr) {
  if (!arr.length) return 0;
  return arr.reduce((a, b) => a + b, 0) / arr.length;
}

export default function MSIClosed() {
    const [closedTrades, setClosedTrades] = useState([]);
    const totalClosed = closedTrades.length;

    const wins = closedTrades.filter(
      (t) => String(t.result).toUpperCase() === "WIN"
    ).length;

    const winRate =
      totalClosed > 0 ? (wins / totalClosed) * 100 : 0;

    const avgReturn = avg(
      closedTrades.map((t) => Number(t.pnl_pct || 0))
    );

    const avgHold = avg(
      closedTrades.map((t) => Number(t.days_open || 0))
    );

    useEffect(() => {
      const savedClosed = localStorage.getItem("msi_closed_positions");
      setClosedTrades(savedClosed ? JSON.parse(savedClosed) : closedSeed);
    }, []);
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0B0B0B",
        color: "white",
        padding: 24,
      }}
    >
      <h1 style={{ fontSize: 40, marginBottom: 4 }}>
        MSI Closed Trades
      </h1>

      <div
        style={{
          color: "#A0A0A0",
          marginBottom: 16,
        }}
      >
        Historical MSI trade performance.
      </div>

      <MSINav />
        
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(180px,1fr))",
            gap: 14,
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <div style={panel}>
            <div style={{ color: "#A0A0A0" }}>Closed Trades</div>
            <div style={{ fontSize: 32, fontWeight: 900 }}>
              {totalClosed}
            </div>
          </div>

          <div style={panel}>
            <div style={{ color: "#A0A0A0" }}>Win Rate</div>
            <div
              style={{
                fontSize: 32,
                fontWeight: 900,
                color: "#22c55e",
              }}
            >
              {fmt(winRate)}%
            </div>
          </div>

          <div style={panel}>
            <div style={{ color: "#A0A0A0" }}>Avg Return</div>
            <div
              style={{
                fontSize: 32,
                fontWeight: 900,
                color: avgReturn >= 0 ? "#22c55e" : "#ef4444",
              }}
            >
              {avgReturn >= 0 ? "+" : ""}
              {fmt(avgReturn)}%
            </div>
          </div>

          <div style={panel}>
            <div style={{ color: "#A0A0A0" }}>Avg Hold</div>
            <div style={{ fontSize: 32, fontWeight: 900 }}>
              {fmt(avgHold)} Days
            </div>
          </div>
        </div>

      <div
        style={{
          ...panel,
          marginTop: 20,
          overflowX: "auto",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr
              style={{
                color: "#A0A0A0",
                textAlign: "left",
              }}
            >
              <th>Ticker</th>
              <th>Contract</th>
              <th>Opened</th>
              <th>Closed</th>
              <th>Days</th>
              <th>Result</th>
              <th>P/L</th>
            </tr>
          </thead>

          <tbody>
            {closedTrades.map((t, idx) => (
              <tr
                key={idx}
                style={{
                  borderTop: "1px solid #2A2A2A",
                }}
              >
                <td>{t.ticker}</td>
                <td>{t.contract}</td>
                <td>{fmtDate(t.opened_at)}</td>
                <td>{fmtDate(t.closed_at)}</td>
                <td>{t.days_open}</td>

                <td
                  style={{
                    color:
                      t.result === "WIN"
                        ? "#22c55e"
                        : "#ef4444",
                    fontWeight: 800,
                  }}
                >
                  {t.result}
                </td>

                <td
                  style={{
                    color:
                      Number(t.pnl_pct) >= 0
                        ? "#22c55e"
                        : "#ef4444",
                    fontWeight: 800,
                  }}
                >
                  {Number(t.pnl_pct) > 0 ? "+" : ""}
                  {fmt(t.pnl_pct)}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {closedTrades.length === 0 && (
          <div
            style={{
              padding: 24,
              color: "#A0A0A0",
            }}
          >
            No closed trades yet.
          </div>
        )}
      </div>
    </div>
  );
}
